import { FetchProductSearchesSortTypes } from './productsSearchesTypes';

export const INITIAL_PRODUCT_SEARCHES_FILTERS = {};
export const INITIAL_PRODUCT_SEARCHES_LIMIT = 100;
export const INITIAL_PRODUCT_SEARCHES_SORT = [
  FetchProductSearchesSortTypes.CREATED_AT_DESC
];

export const EMPTY_PRODUCT_SEARCH_VALUE = '<empty_string>';

export enum ProductsSearchesPermissions {
  READ_PRODUCT_SEARCHES_INDEX_ES_QUERY = 'read_product_searches_index_es_query'
}
